// The official ActionConnect mark — "Linked Chevrons". Two interlocking
// chevrons that read as both a chain-link (connect) and a fast-forward >>
// (action). Rendered inline as SVG so it inherits crisp scaling and a unique
// gradient id per instance (avoids id collisions when multiple logos mount).

import { useId } from "react";

export function Logo({
  size = 28,
  rounded = true,
  title = "ActionConnect",
}: {
  size?: number;
  /** Show the navy rounded tile behind the mark (false = transparent glyph). */
  rounded?: boolean;
  title?: string;
}) {
  const gid = useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#10b981" />
          <stop offset="1" stopColor="#3b82f6" />
        </linearGradient>
      </defs>
      {rounded && <rect width="64" height="64" rx="15" fill="#121a33" />}
      <path
        d="M16 22 L31 32 L16 42"
        fill="none"
        stroke="#2dd4bf"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33 22 L48 32 L33 42"
        fill="none"
        stroke={`url(#${gid})`}
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="32" cy="32" r="4.2" fill="#e7ecf7" />
    </svg>
  );
}
